import {
	DownOutlined,
	FormOutlined,
	LeftOutlined,
} from "@ant-design/icons";
import { Dropdown, Form, Input, Menu, Space, Typography } from "antd";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import React, { useEffect, useState } from "react";
import { DataCourse, statusTypes } from "types";
import "react-quill/dist/quill.snow.css";
import "./style.scss";
import { AddModuleModal, EditModuleModal } from "components";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";

export const ManageModules: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [courseStatus, setCourseStatus] = useState<boolean>(false);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [modules, setModules] = useState<any[]>();
	const [currentModuleInfo, setCurrentModuleInfo] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const navigate = useNavigate();
	// @ts-ignore
	const { state }: { state: { data: DataCourse } } = useLocation();
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();

	const getUpdatedInfo = async (id: string) => {
		setIsLoading(true);
		if (modules) {
			const {
				data: {
					data: { module: courseModule },
				},
			} = await api.get(`/modules/${id}`);
			setIsLoading(false);
			setCurrentModuleInfo(courseModule);
		}
	};

	useEffect(() => {
		setModules(undefined);
		api
			.get(
				`/courses/${
					state.data.id
				}/modules?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setTotalItensValue(Number(res?.data?.pagination?.total));
				setModules(res.data.data.modules);
			});
	}, [state, paginationInfo, selectedValue]);

	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
					width: "30%",
				};
			},
		},
		{
			title: "Aulas",
			dataIndex: "classes_length",
			key: "classes_length",
			render: (length) => (
				<p style={{ margin: 0 }}>{length ? length : "-"} aulas</p>
			),
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Criado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Autor",
			dataIndex: "author",
			key: "author",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => <p style={{ margin: 0 }}>{statusTypes[status]}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	return (
		<div className="m-modules">
			<AddModuleModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				courseId={state.data.id}
				titlePage={`Curso - ${state.data?.title}`}
				setModules={setModules}
			/>
			<EditModuleModal
				form={editForm}
				isOpen={isOpenEdit}
				setIsOpen={setIsOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				courseId={state.data.id}
				titlePage={`Curso - ${state.data?.title}`}
				currentModuleInfo={currentModuleInfo}
				setModules={setModules}
			/>

			<div className="m-modules__container">
				<div
					style={{
						display: "flex",
						width: "100%",
						alignItems: "center",
						marginBottom: "0.9em",
					}}
				>
					<LeftOutlined
						style={{ fontSize: "20px", marginRight: "20px" }}
						onClick={() => window.history.back()}
					/>
					<h1 className="m-modules__container__title">
						Curso - {state.data?.title}
					</h1>
				</div>
				<div className="m-modules__container__input">
					<div className="m-modules__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						módulos
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="m-modules__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Módulo
					</button>
				</div>
				<Table
					//@ts-ignore
					loading={modules === undefined || isLoading}
					columns={columns}
					dataSource={modules}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
